import React, { Component } from 'react';
import { Modal, Row, Button, message, Table, Input, Tooltip } from "antd";
import { inject, observer } from "mobx-react";
import "../../components/app/index.scss";
import "../../components/setting/index.scss";

@inject('store')
@observer
class ExportPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading: false,
            value: '',
            hotel: [],
            hotelTotal: [],
            loadingSave: false,
            selectedRowKeys: []
        }
    }

    async componentDidMount() {
        try {
            let hotel = await this.props.store.menu.getHeadquartersHotels();
            await this.setState({
                hotel: hotel || [],
                hotelTotal: hotel || [],
                loading: false
            });
        } catch (error) {
            this.setState({ loading: false });
            console.error(error);
        }
    }

    onExportPdf = () => {
        const user = JSON.parse(sessionStorage.getItem('user')) || {};
        this.setState({
            visible: true,
            selectedRowKeys: [Number(user.comid || "0")]
        });
    }

    handleOk = () => {
        this.setState({ loadingSave: true });
        fetch(`/chooseHotels?comid=${this.state.selectedRowKeys.toString()}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loadingSave: false });
            if (x.status == 1) {
                sessionStorage.setItem('user', JSON.stringify(x.data));
                message.info('设置成功！');
                this.setState({ visible: false });
                window.location.reload();
            } else {
                message.error(x.msg);
            }
        }).catch(err => {
            this.setState({ loadingSave: false });
            message.info('设置错误！')
            console.error(err);
        })

    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onSearch = () => {
        let hotelTotal = this.state.hotelTotal;
        let name = this.state.name;
        // 去除所有空格不区分大小写
        let hotel = hotelTotal.filter(x => (x.name.toUpperCase().replace(/\s+/g, "")).includes(name.toUpperCase().replace(/\s+/g, "")));
        this.setState({
            hotel
        });
    }
    render() {
        if (!(this.props.user.email || '').includes('admin')) {
            return null
        }

        // 酒店列表
        const columnsHotel = [{
            title: 'key',
            dataIndex: 'id',
            key: 'id',
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '联系人',
            dataIndex: 'contacts',
            key: 'contacts',
        }, {
            title: '地址',
            dataIndex: 'address',
            key: 'address',
        }, {
            title: '联系电话',
            key: 'tel',
            dataIndex: 'tel',
        }];

        const rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (key, selectedRows) => {
                this.setState({ selectedRowKeys: key });
            },
            type: 'radio'
        };
        const user = JSON.parse(sessionStorage.getItem('user')) || {};

        const index = this.state.hotelTotal.findIndex(x => x.id == user.comid);
        const hotelName = this.state.hotelTotal.length > 0 ? index >= 0 ? (this.state.hotelTotal[index].name || "") : '' : '';
        sessionStorage.setItem('hotelName', hotelName);
        const display = this.props.display;
        return (
            <div  >
                <Tooltip title="切换酒店">
                    {!display ? <Button type="primary" icon={hotelName ? 'swap' : 'plus'} onClick={this.onExportPdf} className="menu_select_none" /> : null}
                </Tooltip>
                {display ? <div className="hotel_name">
                    <Button type="primary" className="select_btn" onClick={this.onExportPdf}>选择酒店</Button>
                    <div className="select_hotel_name"> {hotelName ? <div>{hotelName.replace(/[^\u4E00-\u9FA5]/g, "")}<br />{hotelName.replace(/[^a-zA-Z0-9\s]/g, '')}</div> : ''}</div>
                </div> : null}
                <Modal
                    title={'酒店选择'}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={() => this.setState({ visible: false })}
                    className="compared-modal"
                    footer={[
                        <Button key="back" onClick={() => this.setState({ visible: false })}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleOk}>
                            确定
                        </Button>,
                    ]}
                >
                    <Row  >
                        <span>酒店名称：</span>
                        <Input
                            style={{ width: 200, marginRight: 10 }}
                            value={this.state.name}
                            onChange={(e) => {
                                this.setState({
                                    name: (e.target.value || "").trim()
                                });
                            }}
                            onPressEnter={this.onSearch}
                        />
                        <Button
                            type="primary"
                            onClick={this.onSearch}
                        >搜索</Button>
                    </Row>
                    <Table
                        style={{ marginTop: 10 }}
                        columns={columnsHotel}
                        dataSource={this.state.hotel}
                        bordered
                        className="hotelModal"
                        rowSelection={rowSelection}
                        rowKey={item => item.id}
                    />

                </Modal>
            </div>
        );
    }
}

export default ExportPdf;


// WEBPACK FOOTER //
// ./src/bp-views/app/SelectHotel.js